import {
  ApplicableOrNotApplicable,
  HalfYearExtensionReason,
  PapaMamaPlus,
  RetireReason,
} from "../../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../../type/componentsType/TkFakeTableLine";
import {
  IJob_32Props,
  ChildcareActiveListList,
} from "../../../type/contextType/businessContext/IJob_32";
import { TkGetCode } from "../../../utils/TkGetCode";

function funInfoBodyList(listData: any) {
  const infoBody = listData?.map((item: any) => [
    {
      children: String(item.childcareLeaveSerialNo), // 育休連番
    },
    {
      children: item.birthday, // 出生年月日
    },
    {
      children: item.startDate, // 取得開始日
    },
    {
      children: item.endDate, // 取得終了日
    },
    {
      children: TkGetCode(PapaMamaPlus, item.papaMamaFlg), // パパ・ママ育休プラス有無
    },
    {
      children: TkGetCode(
        HalfYearExtensionReason,
        item.halfyearExtensionReason
      ), // 育休半年延長の理由
    },
    {
      children: TkGetCode(PapaMamaPlus, item.papaChildcareLeaveFlg), // 産後パパ育休
    },
  ]);

  return infoBody;
}

function funWorkingDayNumInfoBodyList(listData: any) {
  const infoBody = listData?.map((item: ChildcareActiveListList) => [
    {
      children: `${(item.yearMonth + "").slice(0, 4)}/${(
        item.yearMonth + ""
      ).slice(4)}`,
      align: "center",
    },
    {
      children: `${item.workingDayNum?.toString()}日`, // 出勤日数
      align: "right",
    },
  ]);

  return infoBody;
}

function makeExclusionMonthObj(data: any[], list: ITkFakeTableLineProps[]) {
  let exclusionMonth = list
    .find((item) => item.keyword === "exclusionMonth")!
    .checkBoxList?.filter((item) => item.key !== "none")!;

  let exclusionMonthObj = exclusionMonth.map((item) => {
    if (data.includes(item.label)) {
      if (item.disabled) {
        return [item.key, "3"];
      } else {
        return [item.key, "1"];
      }
    } else {
      if (item.disabled) {
        return [item.key, "2"];
      } else {
        return [item.key, "0"];
      }
    }
  })!;

  const newExclusionMonthObj: { [key: string]: any } = {};

  for (const [key, value] of exclusionMonthObj) {
    newExclusionMonthObj[key] = value;
  }

  return newExclusionMonthObj;
}

function judgeBusinessType(
  data: IJob_32Props
): "JOB-31" | "JOB-33" | "JOB-32" | "" {
  if (data?.nRetireReasonCd !== RetireReason["普通退職"]) {
    return "JOB-31";
  } else if (
    data?.nRetireReasonCd === RetireReason["普通退職"] &&
    data?.continueTransferApplicable1Flg ===
      ApplicableOrNotApplicable["該当"] &&
    data?.continueTransferApplicable2Flg === ApplicableOrNotApplicable["該当"]
  ) {
    return "JOB-33";
  } else {
    return "JOB-32";
  }
}

export {
  funInfoBodyList,
  funWorkingDayNumInfoBodyList,
  makeExclusionMonthObj,
  judgeBusinessType,
};
